import React, { useEffect } from 'react'
import {
  Container,
  Grid,
  makeStyles,
} from '@material-ui/core'
import Page from 'src/components/Page'
import {
  useDispatch,
  useSelector,
} from 'react-redux'
import Budget from './Budget'
import LatestOrders from './LatestOrders'
import LatestProducts from './LatestProducts'
import Sales from './Sales'
import TasksProgress from './TasksProgress'
import TotalCustomers from './TotalCustomers'
// import TotalProfit from './TotalProfit'
import TrafficByDevice from './TrafficByDevice'
import {
  getTopDashboardData, getAgesGroup, getRecentlyRegistered,
  selectorAgeGroup, selectorTopData,
  //  selectorRecentlyRegistered
} from '../../../app/slices/dashboardSlice'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    borderRadius: '20px',
    '@media (max-width: 1270px)': {
      width: '99%',
    }, // const topData = useSelector(selectorTopData)
    // const ageGroup = useSelector(selectorAgeGroup)
    // const recentlyRegistered = useSelector(selectorRecentlyRegistered)
    '@media (max-width: 840px)': {
      width: '100vw',
    },
  },
}))

const Dashboard = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const topData = useSelector(selectorTopData)
  const ageGroup = useSelector(selectorAgeGroup)
  // const recentlyRegistered = useSelector(selectorRecentlyRegistered)

  useEffect(() => {
    dispatch(getTopDashboardData())
    dispatch(getAgesGroup())
    dispatch(getRecentlyRegistered())
  }, [])

  return (
    <Page
      className={classes.root}
      title="داشبورد"
    >
      <Container maxWidth={false}>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            lg={4}
            sm={6}
            xl={4}
            xs={12}
          >
            <Budget topData={topData} />
          </Grid>
          <Grid
            item
            lg={4}
            sm={6}
            xl={4}
            xs={12}
          >
            <TotalCustomers topData={topData} />
          </Grid>
          <Grid
            item
            lg={4}
            sm={6}
            xl={4}
            xs={12}
          >
            <TasksProgress topData={topData} />
          </Grid>
          {/* <Grid
            item
            lg={3}
            sm={6}
            xl={3}
            xs={12}
          >
            <TotalProfit />
          </Grid> */}
          <Grid
            item
            lg={8}
            md={12}
            xl={9}
            xs={12}
          >
            <Sales />
          </Grid>
          <Grid
            item
            lg={4}
            md={6}
            xl={3}
            xs={12}
          >
            <TrafficByDevice ageGroup={ageGroup} />
          </Grid>
          <Grid
            item
            lg={4}
            md={6}
            xl={3}
            xs={12}
          >
            <LatestProducts />
          </Grid>
          <Grid
            item
            lg={8}
            md={12}
            xl={9}
            xs={12}
          >
            <LatestOrders />
          </Grid>
        </Grid>
      </Container>
    </Page>
  )
}

export default Dashboard
